export default {
  state: {
    customRepresentativePriceLists: {},
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    customRepresentativePriceLists: state => state.customRepresentativePriceLists,
    loading: state => state.loading,
    filterString: state => state.filterString,
    sorting: state => state.sorting,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setCustomRepresentativePriceLists(state, customRepresentativePriceLists) {
      state.customRepresentativePriceLists = customRepresentativePriceLists;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
  },
  actions: {
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const customRepresentativePriceLists = await axios.get(`api/representative-price-lists${query || ''}`);
        commit('setCustomRepresentativePriceLists', customRepresentativePriceLists);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },
    async create({ commit }, prices) {
      await axios.post('api/representative-price-lists', prices);
    },
    async update({ commit }, prices) {
      await axios.put('api/representative-price-lists', prices);
    },
    async delete({ commit }, id) {
      await axios.delete('api/representative-price-lists/' + id);
    },
  },
};
